const formatTime = (time: number) => {
  if (time === Infinity) return '00:00'

  const output = []

  if (time && !isNaN(time)) {
    if (time > 3599) {
      output.push(parseInt(String(time / 3600)))
      time %= 3600
    }
    const minutes = Math.floor(time / 60)
    const seconds = Math.floor(time % 60)

    const formatMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`
    const formatSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`

    output.push(formatMinutes, formatSeconds)
    return output.join(':')
  }
  return '00:00'
}

const getPercent = (value: string | number, duration: number) => `${(+value / duration) * 100}%`

export { formatTime, getPercent }
